import './bootstrap'
// Import jQuery JS
import 'jquery-ui/dist/jquery-ui.js'
// Import busy-load JS
import '/public/vendor/busy-load/app.js'
// Import JQuery Datetimepicker JS
import 'jquery-datetimepicker'
jQuery.datetimepicker.setLocale('es')
// Import Pickadate JS Public
// import '/public/vendor/pickadate/lib/picker.js'
// import '/public/vendor/pickadate/lib/picker.date.js'
// import '/public/vendor/pickadate/lib/picker.time.js'
// import '/public/vendor/pickadate/lib/legacy.js'
// import '/public/vendor/pickadate/lib/translations/es_ES.js'

$.busyLoadSetup({
    animation: 'slide',
    background: 'rgba(0, 69, 101, 0.86)', // Color similar a #004565 con opacidad
    spinner: 'cube-grid',
    text: 'Procesando pago...',
    maxSize: '60px',
    minSize: '60px',
})

// Import aos
import AOS from 'aos'
import 'aos/dist/aos.css'

// Add custom CSS for Swiper touch targets
const style = document.createElement('style');
style.innerHTML = `
.swiper-button-next, .swiper-button-prev {
    width: 48px !important;
    height: 48px !important;
    border-radius: 24px;
    background: rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin: 8px;
}
.swiper-pagination-bullet {
    width: 20px !important;
    height: 20px !important;
    margin: 0 8px !important;
}
`;
document.head.appendChild(style);

// Inicializa AOS
AOS.init({
    // Opciones globales (opcional):
    duration: 800, // Duración de la animación (ms)
    easing: 'ease-in-out', // Tipo de easing (ej: 'ease', 'ease-in-out')
    once: true, // Animación solo una vez
    offset: 100, // Offset (px) desde el borde inferior
})

// Import AnimateCSS
import 'animate.css'

// import Swiper JS
import Swiper from 'swiper/bundle'

function initSwiperOnElements(selector, options) {
    document.querySelectorAll(selector).forEach((element) => {
        if (element.classList.contains('swiper-initialized')) {
            return
        }

        new Swiper(element, options)
    })
}

// Home - Brands Slider
const brandsSliderOptions = {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 3,
        },
    },
    lazy: {
        loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
        loadPrevNextAmount: 2, //or, if you wish, preload the next 2 images
    },
}

// Shuttle - Reviews Slider
const reviewsSliderOptions = {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 4,
        },
    },
}

// Shuttle - Services Slider
const servicesSliderOptions = {
    loop: true,
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 4,
        },
    },
}

// Shuttle - Press Slider
const pressSliderOptions = {
    direction: 'horizontal',
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    pagination: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    breakpoints: {
        // When the viewport is >= 768px
        768: {
            slidesPerView: 1, // Show 2 slides on tablets
            spaceBetween: 20,
        },
        // When the viewport is >= 1024px
        1024: {
            slidesPerView: 3, // Show 3 slides on desktop
            spaceBetween: 30,
        },
    },
    on: {
        init: function () {
            showActiveText(this)
        },
        slideChange: function () {
            showActiveText(this)
        },
    },
}

function initializeAllSwipers() {
    initSwiperOnElements('.swiper-brands', brandsSliderOptions)
    initSwiperOnElements('.swiper-reviews', reviewsSliderOptions)
    initSwiperOnElements('.swiper-services', servicesSliderOptions)
    initSwiperOnElements('.swiper-press', pressSliderOptions)
}

initializeAllSwipers()

const swiperObserver = new MutationObserver(() => {
    initializeAllSwipers()
})

swiperObserver.observe(document.body, {
    childList: true,
    subtree: true,
})

function showActiveText(swiperInstance) {
    document.querySelectorAll('.swiper-press-text').forEach(function (el) {
        el.classList.add('d-none')
    })
    var activeSlide = swiperInstance.slides[swiperInstance.activeIndex]
    if (activeSlide) {
        var text = activeSlide.querySelector('.swiper-press-text')
        if (text) {
            text.classList.remove('d-none')
        }
    }
}
